var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"narrow-container"},[_c('f-view-heading',{attrs:{"first-column-width":"9","title":_vm.$t('view_validator_detail.title')}}),_c('f-validator-detail',{attrs:{"address":_vm.$route.params.address}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }